exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".well[data-v-5e6ce31f]{border-radius:15px;border:1px solid #273147;background-color:#172131}@media (max-width:600px){h2[data-v-5e6ce31f]{font-size:1.5rem}}a[data-v-5e6ce31f]{color:#fff;text-decoration-line:none;transition:.2s ease-in-out}a[data-v-5e6ce31f]:hover{color:#f05f40}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5e6ce31f","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Games.vue
// module id = 27
// module chunks = 0